(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ekw-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ekw-hero-video')) {
    customElements.define('ekw-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        this.video = this.querySelector('video');
        this.button = this.querySelector('.ekw-home__video-toggle');
        this.audio = this.querySelector('audio');
        this.soundButton = this.querySelector('.ekw-home__sound-toggle');
        this.status = this.querySelector('.ekw-home__media-status');
        if (!this.video || !this.button) return;

        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.soundEnabled = false;
        this.videoRequest = (this.videoRequest || 0) + 1;
        this.audioRequest = (this.audioRequest || 0) + 1;
        this.video.muted = true;
        this.video.controls = false;
        this.audio?.pause();
        this.querySelector('.ekw-home__media-controls').hidden = false;

        const updateButton = () => {
          this.button.textContent = this.video.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
        };
        const updateSoundButton = () => {
          if (!this.soundButton) return;
          this.soundButton.textContent = this.soundEnabled ? this.soundButton.dataset.soundOffLabel : this.soundButton.dataset.soundOnLabel;
        };
        const pauseAudio = () => {
          this.audioRequest += 1;
          this.audio?.pause();
        };
        const soundFailed = () => {
          this.soundEnabled = false;
          pauseAudio();
          updateSoundButton();
          if (this.status) this.status.textContent = this.soundButton.dataset.errorLabel;
        };
        const playAudio = () => {
          if (!this.audio || !this.soundEnabled || this.video.paused || !this.audio.paused || this.video.error) return;
          const request = ++this.audioRequest;
          this.audio.play().catch(() => {
            if (this.isConnected && request === this.audioRequest) soundFailed();
          });
        };
        const playVideo = () => {
          const request = ++this.videoRequest;
          this.video.play().catch(() => {
            if (!this.isConnected || request !== this.videoRequest) return;
            pauseAudio();
            if (this.soundEnabled) soundFailed();
            updateButton();
          });
          playAudio();
        };
        const pauseVideo = () => {
          this.videoRequest += 1;
          this.video.pause();
          pauseAudio();
        };

        this.video.addEventListener('play', () => {
          updateButton();
          playAudio();
        }, options);
        this.video.addEventListener('pause', () => {
          updateButton();
          pauseAudio();
        }, options);
        this.video.addEventListener('error', () => {
          pauseAudio();
          if (this.soundEnabled) soundFailed();
          this.button.hidden = true;
          if (this.soundButton) this.soundButton.hidden = true;
          this.video.controls = true;
        }, options);
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            playVideo();
          } else {
            this.userPaused = true;
            pauseVideo();
          }
        }, options);
        this.soundButton?.addEventListener('click', () => {
          this.soundEnabled = !this.soundEnabled;
          this.status.textContent = '';
          updateSoundButton();
          if (!this.soundEnabled) {
            pauseAudio();
          } else if (this.video.paused) {
            this.userPaused = false;
            playVideo();
          } else {
            playAudio();
          }
        }, options);
        this.audio?.addEventListener('error', soundFailed, options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            pauseVideo();
          } else if (!this.userPaused) {
            playVideo();
          }
        }, options);

        updateButton();
        updateSoundButton();
        if (!this.motion.matches) playVideo();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.controller?.abort();
        this.videoRequest += 1;
        this.audioRequest += 1;
        this.soundEnabled = false;
        this.video?.pause();
        this.audio?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
